import {REPORT_JOB_TYPES} from './reportJobLists';
import {setSystemToLowercase} from './serverFunctions';

/**
 * Assemble a query for retrieving Job Report list
 *
 * @param params
 * @returns {string}
 */
export const assembleReportJobQuery = (params) => {
    let q = '?limit=' + params.limit + '&offset=' + params.offset;
    if (params.sort.id) {
        q += '&sort=' + params.sort.id;
        let order = (params.sort.desc) ? 'desc' : 'asc';
        q += '&order=' + order;
    }
    if (params.search && params.search !== '' && params.searchable.length > 0) {
        params.searchable.forEach((item, idx) => {
            q += '&searchable[]=' + item;
        });
        q += '&search=' + encodeURIComponent(params.search);
    }
    if (params.filterColumn && params.filterValue) {
        q += '&filterColumn=' + params.filterColumn;
        q += '&filterValue=' + encodeURIComponent(params.filterValue);
    }
    return q;
};

/**
 * Assemble Report Job form details based on Report Job Type selection
 *
 * @param reportType
 */
export const setReportJobFormDetails = (reportType) => {
    const details = REPORT_JOB_TYPES.find(r => r.id === reportType);
    if (details) {
        return {
            name: details.name,
            description: details.description,
            instructions: details.instructions
        }
    }
    return {
        name: '',
        description: '',
        instructions: ''
    }
};

/**
 * Determine what form elements to display and store based on Report Job Type selection
 *
 * @param reportType
 */
export const setReportJobParams = (reportType) => {
    let include = {
        active: false,
        dateRange: false,
        fraudLocked: false,
        offset: false,
        locations: false,
        top: false
    };
    if (reportType === 'combined-sales') {
        include.dateRange = true;
        include.locations = true;
        include.offset = true;
    }
    if (reportType === 'discount') {
        include.dateRange = true;
        include.locations = true;
        include.offset = true;
    }
    if (reportType === 'loyalty') {
        include.active = true;
        include.dateRange = true;
        include.fraudLocked = true;
    }
    if (reportType === 'loyalty-top-earners') {
        include.dateRange = true;
        include.top = true;
    }
    return include;
};

/**
 * Assemble a valid payload to submit a new Report Job
 *
 * @param reportType
 * @param values
 */
export const assembleReportJobPayload = (reportType, values) => {
    let payload = {
        name: (values.name) ? values.name : '',
        description: (values.description) ? values.description : '',
        args: assembleReportJobParams(reportType, values)
    };
    const reportObj = REPORT_JOB_TYPES.find(r => r.id === reportType);
    if (reportObj) {
        payload.class = reportObj.class;
        payload.method = reportObj.method;
        payload.package = reportObj.worker_package;
    }

    return payload;
};

/**
 * Assemble parameters from Report Job form data
 *
 * @param reportType
 * @param values
 */
export const assembleReportJobParams = (reportType, values) => {
    const system = setSystemToLowercase();
    let args = {
        system: system
    };
    if (reportType === 'discount' || reportType === 'loyalty' || reportType === 'combined-sales') {
        args.report_cfg = {
            dateRange: {
                fromDay: (values.date_from) ? values.date_from : '',
                toDay: (values.date_to) ? values.date_to : ''
            }
        };
    }
    if (reportType === 'discount' || reportType === 'combined-sales') {
        args.report_cfg.dateRange.tz = (values.offset) ? values.offset : '';
        args.report_cfg.location = {
            cities: (values.cities && values.cities.length > 0) ? values.cities : [],
            dbas: (values.dbas && values.dbas.length > 0) ? values.dbas : [],
            districts: (values.districts && values.districts.length > 0) ? values.districts : [],
            locations: (values.locations && values.locations.length > 0) ? values.locations : [],
            states: (values.states && values.states.length > 0) ? values.states : []
        };
    }
    if (reportType === 'loyalty') {
        args.report_cfg.active = (values.active && values.active === true) ? values.active : false;
        args.report_cfg.fraudLocked = (values.fraud_locked) ? values.fraud_locked : false;
    }
    if (reportType === 'loyalty-top-earners') {
        args.date_from = (values.date_from) ? values.date_from : '';
        args.date_to = (values.date_to) ? values.date_to : '';
        args.top = (values.top) ? parseInt(values.top, 10) : 10;
    }
    // Add Location selections
    const filterTypes = values.filter_types;
    const filterChoice = values.filter_first_choice;
    if (filterTypes) {
        if (filterTypes === 'dba' && filterChoice) {
            args.report_cfg.location.dbas.push(filterChoice);
        }
        if (filterTypes === 'district' && filterChoice) {
            args.report_cfg.location.districts.push(filterChoice);
        }
        if (filterTypes === 'location' && filterChoice) {
            args.report_cfg.location.locations.push(filterChoice);
        }
        if (filterTypes === 'state' && filterChoice) {
            args.report_cfg.location.states.push(filterChoice);
        }
        if (filterTypes === 'locations') {
            args.report_cfg.location.locations = values.filter_locations;
        }
    }
    return args;
};

/**
 * Extract Report select options from Job Config for a single Category
 *
 * @param type
 * @param obj
 * @returns {*[]}
 */
export const assembleSelectOptionsFromConfigData = (type, obj) => {
    let list = [];
    Object.keys(obj).forEach(key => {
        const title = obj[key]['title'];
        const desc = obj[key]['description'];
        if (key !== 'error') {
            list.push({
                key: key,
                id: key,
                name: (title) ? title : key,
                title: (title) ? title : key,
                description: (desc) ? desc : ''
            });
        }
    });
    return list;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/reportJobFunctions.js